import { Link } from 'react-router-dom';
export default function Contact() {
  return <section id="contact-us" className="studio-contact"><div className="studio-shell contact-layout">
    <div><p className="studio-eyebrow">มาทำให้งานง่ายขึ้น</p><h2>บอกเราเกี่ยวกับงาน<br />ที่คุณอยากทำให้ง่ายขึ้น</h2><p>เล่าว่าทีมทำงานอย่างไรในวันนี้ และส่วนไหนใช้เวลานาน รวมเครื่องมือที่ใช้ไว้ด้วย เพื่อให้เราเตรียมเดโมที่เกี่ยวข้องได้</p><p className="contact-location">สำหรับเจ้าของธุรกิจ ผู้ก่อตั้ง และทีมปฏิบัติการในสิงคโปร์และไทย</p></div>
    <Link to="/th/#request-demo" className="contact-action"><span aria-hidden="true">↗</span>ขอดูเดโม</Link>
  </div></section>;
}
